// Mock data for Enseignes3D.fr (FR)

export const STRUCTURE_TYPES_FR = [
  { id: 'B', icon: 'B', label: 'Lettres boîtier (lumineuses)',
    desc: 'Fond + parois en une seule pièce creuse, face clipsée par l\'avant',
    assembly: 'box-clip', assemblyLabel: 'Boîtier ouvert, face clipsée par l\'avant' },
  { id: 'L', icon: 'L', label: 'Acrylique inseré par l\'intérieur',
    desc: 'L\'acrylique se clipse à l\'intérieur de la structure',
    assembly: 'interior-clip', assemblyLabel: 'Se clipse à l\'intérieur' },
  { id: 'F', icon: 'F', label: 'Acrylique inséré à mi-hauteur',
    desc: 'L\'acrylique s\'emboite à mi-paroi par l\'intérieur',
    assembly: 'mid-wall', assemblyLabel: 'Emboité à mi-paroi' },
  { id: 'C', icon: 'C', label: 'Sans acrylique (face pleine)',
    desc: 'Face avant pleine en matériau opaque, sans acrylique',
    assembly: 'solid', assemblyLabel: 'Face pleine monolithique' },
  { id: 'P', icon: 'P', label: 'Face perforée avec acrylique intérieur',
    desc: 'Face avant perforée, acrylique emboité par l\'extérieur',
    assembly: 'exterior-fit', assemblyLabel: 'S\'emboite par l\'extérieur' },
];
export const STRUCTURE_TYPES = STRUCTURE_TYPES_FR;
export const LANGUAGES = ['FR', 'EN', 'ES', 'IT'];
export const ORIENTATIONS = [
  { id: 'F', label: 'Avant' }, { id: 'T', label: 'Dessus' }, { id: 'I', label: 'Iso' },
  { id: 'D', label: 'Arrière' }, { id: 'S', label: 'Côté' }, { id: 'B', label: 'Dessous' },
  { id: 'L', label: 'Libre' },
];

// Material types - photo-realistic-ish properties
export const MATERIAL_TYPES = [
  { id: 'pmma', name: 'PMMA (Acrylique)', desc: 'Plexiglas diffusant ou transparent',
    swatchBg: 'linear-gradient(135deg, #f6f9fa 0%, #c5dce4 100%)',
    visual: { roughness: 0.06, metalness: 0, transparent: true, opacity: 0.95, transmission: 0.3, clearcoat: 1, emissiveBase: 0.12 } },
  { id: 'petg', name: 'PETG (impression 3D)', desc: 'Filament PETG opaque, légère brillance',
    swatchBg: 'linear-gradient(135deg, #d4d4d8 0%, #565660 100%)',
    visual: { roughness: 0.45, metalness: 0.05, transparent: false, opacity: 1, clearcoat: 0.2 } },
  { id: 'pvc', name: 'PVC', desc: 'PVC opaque mat ou semi-mat',
    swatchBg: 'linear-gradient(135deg, #4a4a4e 0%, #1a1a1e 100%)',
    visual: { roughness: 0.75, metalness: 0.02, transparent: false, opacity: 1, clearcoat: 0 } },
  { id: 'wood', name: 'Bois (découpe)', desc: 'Contreplaqué, MDF, hêtre - aspect bois',
    swatchBg: 'linear-gradient(135deg, #d9a86b 0%, #6e3f12 100%)',
    visual: { roughness: 0.88, metalness: 0, transparent: false, opacity: 1, clearcoat: 0 } },
];

// PMMA color swatches (Plexiglas / Setacryl realistic refs)
export const PMMA_COLORS = [
  { id: 'opal-white', name: 'Blanc Opale', hex: '#f5f5f0', preview: 'linear-gradient(135deg, #ffffff 0%, #e8e8e0 100%)', translucent: true },
  { id: 'crystal-clear', name: 'Cristal transparent', hex: '#e8f4f8', preview: 'linear-gradient(135deg, #f0fafd 0%, #c5dde6 100%)', transparent: true },
  { id: 'satin-white', name: 'Blanc Satiné', hex: '#fafaf6', preview: 'linear-gradient(135deg, #fefefe 0%, #ededdf 100%)' },
  { id: 'red', name: 'Rouge 3H02', hex: '#c41718', preview: 'linear-gradient(135deg, #e8242a 0%, #8e0d10 100%)' },
  { id: 'pink', name: 'Rose Fluo 7E01', hex: '#ec1d8c', preview: 'linear-gradient(135deg, #ff3aa3 0%, #b00b66 100%)' },
  { id: 'orange', name: 'Orange Fluo 7E03', hex: '#ff7f00', preview: 'linear-gradient(135deg, #ffa14a 0%, #d65800 100%)' },
  { id: 'yellow', name: 'Jaune Citron 1H01', hex: '#ffdd00', preview: 'linear-gradient(135deg, #fff066 0%, #d4b800 100%)' },
  { id: 'green', name: 'Vert Pomme 6H02', hex: '#3aaa35', preview: 'linear-gradient(135deg, #5cc855 0%, #1f7f1c 100%)' },
  { id: 'blue', name: 'Bleu Roi 5H21', hex: '#1a4ec3', preview: 'linear-gradient(135deg, #3268d8 0%, #0d2f80 100%)' },
  { id: 'turquoise', name: 'Turquoise 5H82', hex: '#1ab6c4', preview: 'linear-gradient(135deg, #3acdda 0%, #0e7d87 100%)' },
  { id: 'black', name: 'Noir intense 9H01', hex: '#0a0a0a', preview: 'linear-gradient(135deg, #2a2a2a 0%, #000000 100%)' },
  { id: 'gold-mirror', name: 'Miroir Or', hex: '#d4af37', preview: 'linear-gradient(135deg, #ffe486 0%, #a47b1b 100%)' },
  { id: 'silver-mirror', name: 'Miroir Argent', hex: '#c8c8c8', preview: 'linear-gradient(135deg, #f0f0f0 0%, #888888 100%)' },
];

// PETG filament colors
export const PETG_COLORS = [
  { id: 'petg-white', name: 'Blanc', hex: '#f7f7f5', preview: 'linear-gradient(135deg, #ffffff 0%, #e0e0d8 100%)' },
  { id: 'petg-black', name: 'Noir Mat', hex: '#161616', preview: 'linear-gradient(135deg, #2c2c2c 0%, #050505 100%)' },
  { id: 'petg-gray', name: 'Gris Anthracite', hex: '#3a3a3e', preview: 'linear-gradient(135deg, #58585e 0%, #1c1c20 100%)' },
  { id: 'petg-red', name: 'Rouge', hex: '#c01818', preview: 'linear-gradient(135deg, #e02828 0%, #800808 100%)' },
  { id: 'petg-pink', name: 'Rose Magenta', hex: '#ec1d8c', preview: 'linear-gradient(135deg, #ff44a5 0%, #a30e60 100%)' },
  { id: 'petg-blue', name: 'Bleu', hex: '#1c5cc8', preview: 'linear-gradient(135deg, #3a7ce0 0%, #0e3a8a 100%)' },
  { id: 'petg-green', name: 'Vert', hex: '#1f9d3a', preview: 'linear-gradient(135deg, #36c855 0%, #0e6824 100%)' },
  { id: 'petg-yellow', name: 'Jaune', hex: '#f5c813', preview: 'linear-gradient(135deg, #ffe055 0%, #b09000 100%)' },
  { id: 'petg-orange', name: 'Orange', hex: '#ee7a18', preview: 'linear-gradient(135deg, #ff9a45 0%, #b65508 100%)' },
  { id: 'petg-silver', name: 'Argenté', hex: '#b8b8c0', preview: 'linear-gradient(135deg, #d8d8e0 0%, #707080 100%)' },
  { id: 'petg-gold', name: 'Or', hex: '#c89c2a', preview: 'linear-gradient(135deg, #f0c860 0%, #7a5e10 100%)' },
  { id: 'petg-transparent', name: 'Transparent', hex: '#dde8ec', preview: 'linear-gradient(135deg, #ecf4f7 0%, #a8c0c8 100%)' },
];

// PVC colors
export const PVC_COLORS = [
  { id: 'pvc-black', name: 'Noir', hex: '#0e0e10', preview: 'linear-gradient(135deg, #2a2a2e 0%, #000000 100%)' },
  { id: 'pvc-white', name: 'Blanc', hex: '#f0f0eb', preview: 'linear-gradient(135deg, #ffffff 0%, #d8d8d2 100%)' },
  { id: 'pvc-gray', name: 'Gris', hex: '#7a7a7e', preview: 'linear-gradient(135deg, #9d9da0 0%, #4a4a4e 100%)' },
  { id: 'pvc-red', name: 'Rouge', hex: '#a8181c', preview: 'linear-gradient(135deg, #c82a30 0%, #6a0a0e 100%)' },
  { id: 'pvc-blue', name: 'Bleu', hex: '#14488a', preview: 'linear-gradient(135deg, #2862ad 0%, #082c5a 100%)' },
];

// Wood finishes
export const WOOD_COLORS = [
  { id: 'wood-oak', name: 'Chêne clair', hex: '#d9a86b', preview: 'linear-gradient(135deg, #e5bd85 0%, #a47543 100%)' },
  { id: 'wood-walnut', name: 'Noyer', hex: '#5e3818', preview: 'linear-gradient(135deg, #7a4c25 0%, #3a1f0a 100%)' },
  { id: 'wood-pine', name: 'Pin', hex: '#dcb98a', preview: 'linear-gradient(135deg, #ebcfa6 0%, #b48857 100%)' },
  { id: 'wood-mdf', name: 'MDF brut', hex: '#c4a37a', preview: 'linear-gradient(135deg, #d8baa0 0%, #8e6e4a 100%)' },
  { id: 'wood-ebony', name: 'Ébène', hex: '#1a0f08', preview: 'linear-gradient(135deg, #2e1d10 0%, #050200 100%)' },
  { id: 'wood-cherry', name: 'Cerisier', hex: '#7a3318', preview: 'linear-gradient(135deg, #a04428 0%, #4a1808 100%)' },
];

export function getColorsForMaterial(materialId) {
  switch (materialId) {
    case 'pmma': return PMMA_COLORS;
    case 'petg': return PETG_COLORS;
    case 'pvc':  return PVC_COLORS;
    case 'wood': return WOOD_COLORS;
    default: return PMMA_COLORS;
  }
}

export const FONTS = [
  { name: 'Helvetiker (Gras)', url: '/fonts/helvetiker_bold.typeface.json' },
  { name: 'Optimer (Gras)', url: '/fonts/optimer_bold.typeface.json' },
  { name: 'Gentilis (Gras)', url: '/fonts/gentilis_bold.typeface.json' },
  { name: 'Droid Sans (Gras)', url: '/fonts/droid/droid_sans_bold.typeface.json' },
];

export const DEFAULT_PROJECT = {
  inputMode: 'text',
  fontIndex: 0,
  structureType: 'B',
  dimensions: { height: 150, depth: 40, wallThickness: 3, acrylicThickness: 5 },
  light: { intensity: 1.2, horizontal: 86, height: 168, enabled: true },
  partsVisibility: { walls: true, back: true, front: true },
  ledOn: false,
  ledDensity: 60,
  showGrid: true,
};
